import MultiplexApi from "../MultiplexApi.ts";
import * as i18n from "../../i18n.ts";
import {ListCache} from "../../lib/SyncCache.ts";
import { ColorBean } from "../fizapilib.auto.ts";

export const ColorCache = new ListCache<ColorBean>(MultiplexApi.colorlist);

declare module "../fizapilib.auto.ts" {
  interface ColorBean {
    defaultName: string
  }
  
}

ColorBean.prototype.onDecode = function(json: any): void {
  this.defaultName = i18n.get("color."+this.colorSystem);
  this.name = this.name ? this.name.trim().replace(/\s+/g,' ') : this.defaultName;
}
